import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Details = styled.span`
  display: block;
  font-size: 10px;
  margin-bottom: 3px;
`

export const Wrapper = styled.div`
  font: ${font('default', 'normal', '10px/1.5')} !important;
`

export const Header = styled.div`
  img {
    height: 70px;
  }
`

export const Footer = styled.div`
  position: absolute;
  bottom: 5px;
  font-size: 9px;
  border-top: 1px solid ${props => props.theme.palette.general.greyMed2};
  padding-top: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Container = styled.div`
  position: relative;
  height: 560px;
  font-family: Arial, sans-serif;
  margin: 5px;
`

export const WholeWrapper = styled.div`
  position: absolute;
  left: -100000px;
`
